import { render, staticRenderFns } from "./resend-sms.vue?vue&type=template&id=9ae3f2b0&"
import script from "./resend-sms.vue?vue&type=script&lang=js&"
export * from "./resend-sms.vue?vue&type=script&lang=js&"
import style0 from "./resend-sms.vue?vue&type=style&index=0&id=9ae3f2b0&prod&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports